var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var WarningSign = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 19 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c, _d = _a.fill, fill = _d === void 0 ? "#993838" : _d, className = _a.className;
    return (_jsx("svg", __assign({ width: width, height: height, viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className }, { children: _jsx("path", { d: "M10 10V5.82031H8.35938V10H10ZM10 13.3203V11.6406H8.35938V13.3203H10ZM0 15.8203L9.17969 0L18.3594 15.8203H0Z", fill: fill }) })));
};
export default WarningSign;
